import { orpc } from "@/utils/orpc.client";
import { QUERY_STALE_TIMES } from "@/utils/query-policies";

interface ReleaseListingsQueryOptionsInput {
  releaseId: string;
  currency: string;
  enabled?: boolean;
}

export function getReleaseListingsQueryOptions({
  releaseId,
  currency,
  enabled,
}: ReleaseListingsQueryOptionsInput) {
  return orpc.marketplace.getListingsForRelease.queryOptions({
    input: { releaseId, currency },
    enabled,
    staleTime: QUERY_STALE_TIMES.marketplaceListings,
  });
}
